/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { GlossaryBatchOperation, GlossaryEntry, List } from "./data-contracts";

/**
 * No description
 * @tags glossary
 * @name ListGlossaryEntries
 * @summary List glossary entries
 * @request GET:/orgs/{organizationId}/translations-glossary
 * @secure
 */

// @ts-ignore
export const listGlossaryEntries: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: GlossaryEntry[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/translations-glossary",
  method: "get",
  streaming: false,
  tags: ["glossary"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags glossary
 * @name UpdateGlossaryEntries
 * @summary Update glossary entries
 * @request PUT:/orgs/{organizationId}/translations-glossary
 * @secure
 */

// @ts-ignore
export const updateGlossaryEntries: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: {
    operations: GlossaryBatchOperation[];
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 400;
} = {
  route: "/orgs/{organizationId}/translations-glossary",
  method: "put",
  streaming: false,
  tags: ["glossary"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags glossary
 * @name GetGlossaryEntry
 * @summary Get a glossary entry by its ID
 * @request GET:/orgs/{organizationId}/translations-glossary/{glossaryEntryId}
 * @secure
 */

// @ts-ignore
export const getGlossaryEntry: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the glossary entry */
    glossaryEntryId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: GlossaryEntry;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/translations-glossary/{glossaryEntryId}",
  method: "get",
  streaming: false,
  tags: ["glossary"],
  criticalityLevel: "low",
  deprecated: false,
};
